// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","authorizeAgent":"AuthorizeAgent__authorizeAgent--Xr","comment":"AuthorizeAgent__comment--fo","poolSelectPopup":"AuthorizeAgent__poolSelectPopup--Wc"};